import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Self-hosted variable fonts — no third-party request, no FOUT from a blocked CDN.
import '@fontsource-variable/montserrat';
import '@fontsource-variable/montserrat/wght-italic.css';
import '@fontsource-variable/fraunces';
import '@fontsource-variable/fraunces/wght-italic.css';
import '@fontsource-variable/jost';
import '@fontsource-variable/jost/wght-italic.css';

// IMPORTANT: the global layer must be imported BEFORE any component, otherwise
// webpack emits it last and base rules (.frame, .btn …) win ties against the
// component overrides that are meant to refine them.
import './styles/global.css';

import App from './App';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
